import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';

import { EquipmentSetsProps } from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { makeSelectEntitiesRowSpacing } from 'services/equipmentSets/selectors';
import { EntityRowSpacing } from 'services/entities/types';
import WarningMessage from 'components/WarningMessage';
import RowSpacingsWithCorrectSetupAlert from './components/RowSpacingsWithCorrectSetupAlert';
import RowSpacingsWithInvalidRateAlert from './components/RowSpacingsWithInvalidRateAlert';
import RowSpacingsWithoutCalibrationsAlert from './components/RowSpacingsWithoutCalibrationsAlert';

type OwnProps = EquipmentSetsProps;

interface ConnectedProps {
    entitiesRowSpacing?: EntityRowSpacing[];
}

export type Props = ConnectedProps & OwnProps;

export class StatusComponent extends React.PureComponent<Props> {
    render(): ReactElement | null {
        const {
            equipmentSetId,
            entitiesRowSpacing,
            applicationRate,
            entityIds
        } = this.props;

        if (entitiesRowSpacing && !entitiesRowSpacing.length) {
            return (
                <Grid.Row className="calibration-status">
                    <Grid.Column>
                        <div className="calibration-status-section">
                            <WarningMessage
                                title="All selected areas have no row width value set."
                                visible
                            />
                        </div>
                    </Grid.Column>
                </Grid.Row>
            );
        }

        if (equipmentSetId) {
            return (
                <div className="calibration-status">
                    <RowSpacingsWithCorrectSetupAlert
                        equipmentSetId={equipmentSetId}
                        entityIds={entityIds}
                        applicationRate={applicationRate}
                    />
                    <RowSpacingsWithInvalidRateAlert
                        equipmentSetId={equipmentSetId}
                        entityIds={entityIds}
                        applicationRate={applicationRate}
                    />
                    <RowSpacingsWithoutCalibrationsAlert
                        equipmentSetId={equipmentSetId}
                        entityIds={entityIds}
                        applicationRate={applicationRate}
                    />
                </div>
            );
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entitiesRowSpacing: makeSelectEntitiesRowSpacing()
});

export default connect(mapStateToProps)(StatusComponent);
